import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../api';
import { AppState } from '../../../../store/models/app-state';
import { ReduxDispatch } from '../../../../store/use-thunk-dispatch';

export const HEADER_BANNER_DELETED = 'HEADER_BANNER_DELETED';

export const headerBannerDeleted = (id: number) => {
    return {
        type: HEADER_BANNER_DELETED,
        id,
    };
};

export const deleteHeaderBanner = (id: number) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(headerBannerDeleted(id));

        const response = await api.contentManagement.HeaderBanner.deleteHeaderBanner(id);

        if (!response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
